module.exports = __webpack_public_path__ + "img/add-grey.eb3b80b8.svg";